const apiUrl = process.env.REACT_APP_API_URL;
export const checkUser = async ( usuari : string, password : string ) => {
    try {
        const response = await fetch(`${apiUrl}:8061/login`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ usuari, password })
        });
        if (response.ok) {
            const jsonData = await response.json();
            return jsonData;
        } else {
            return "ERROR";
        }

    } catch (error) {
        console.log('Error al obtener los datos:', error);
    }
};
